import { Controller, useFormContext, useWatch } from "react-hook-form"
import { Input, Button } from "components"
import type { BuyingList, BuyingProps } from "../../types"
import { DataTable } from "../ChildItem/components/Item/components/FormBuying/DataTable"
import { useDetailBuyingPrice } from "../ChildItem/components/Item/utils"
import { convertNumber } from "utils"

export const FormBuying = ({ action, onSubmit, checkLoading, setCheckLoading, setBuyingPrice, permission }: BuyingProps) => {
  const { control } = useFormContext<BuyingList>()
  const methods = useFormContext<BuyingList>() 

  const product_id = useWatch({ control, name: "product_id" })

  const detailBuying = useDetailBuyingPrice(Number(product_id)) 
  const detail = detailBuying?.data
  
  return (
    <div>
      <section>
        <DataTable action={action} checkLoading={checkLoading} setCheckLoading={setCheckLoading} setBuyingPrice={setBuyingPrice} />

        <div>
          <Controller
            control={control}
            name="tax_id"
            render={({ field }) => 
              <Input 
                {...field} 
                label="LAST PURCHASED TRANSACTION" 
                type="text"
                value={detail?.last_purchased_transaction ?? "0"}
                disabled 
              />
            }
          />
          <Controller
            control={control}
            name="tax_id"
            render={({ field }) => 
              <Input 
                {...field} 
                label="LAST SOLD TRANSACTION" 
                type="text" 
                value={detail?.last_sold_transaction ? convertNumber(detail?.last_sold_transaction)?.intoCurrency : "0"}
                disabled 
              />
            }
          />
          <Controller
            control={control}
            name="tax_id"
            render={({ field }) => 
              <Input 
                {...field} 
                label="STOCK IN" 
                type="text" 
                value={detail?.stock_in ? convertNumber(detail?.stock_in)?.intoCurrency : "0"}
                disabled 
              />
            }
          />
          <Controller
            control={control}
            name="tax_id"
            render={({ field }) => 
              <Input 
                {...field} 
                label="STOCK OUT" 
                type="text" 
                value={detail?.stock_out ? convertNumber(detail?.stock_out)?.intoCurrency : "0"}
                disabled 
              />
            }
          />
          <Controller
            control={control}
            name="tax_id"
            render={({ field }) => 
              <Input 
                {...field} 
                label="QUANTITY ON HAND" 
                type="text" 
                value={detail?.quantity_on_hand ? convertNumber(detail?.quantity_on_hand)?.intoCurrency : "0"}
                disabled 
              />
            }
          />
          <Controller
            control={control}
            name="tax_id"
            render={({ field }) => 
              <Input 
                {...field} 
                label="COGM VALUE" 
                type="text" 
                value={detail?.cogm_value ? convertNumber(detail?.cogm_value)?.intoCurrency : "0"}
                disabled 
              />
            }
          />
          <Controller
            control={control}
            name="tax_id"
            render={({ field }) => 
              <Input 
                {...field} 
                label="AVERAGE COST" 
                type="text" 
                value={detail?.average_cost ? convertNumber(Math.round(detail?.average_cost))?.intoCurrency : "0"}
                disabled 
              />
            }
          />
          <Controller
            control={control}
            name="tax_id"
            render={({ field }) => 
              <Input 
                {...field} 
                label="ON ORDER" 
                type="text" 
                value={detail?.on_order ? convertNumber(detail?.on_order)?.intoCurrency : "0"}
                disabled 
              />
            }
          />
          <Controller
            control={control}
            name="tax_id"
            render={({ field }) => 
              <Input 
                {...field} 
                label="AVAILABLE" 
                type="text" 
                value={detail?.available ? convertNumber(detail?.available)?.intoCurrency : "0"}
                disabled 
              />
            }
          />
        </div>
      </section>
      {action !== "DETAIL" &&
        <div className="flex justify-end">
          <Button
            type="button"
            color="primary"
            className="mt-5" 
            permission={permission}
            loading={methods.formState.isSubmitting ? "true" : undefined}
            onClick={onSubmit}
          >
            {action === "UPDATE" ? "UPDATE" : "SAVE"}
          </Button>
        </div>
      }
    </div>
  )
}